import React from "react";
import { Text } from "@kui/foundations-react";
import HorizontalRule from "../util/HorizontalRule";
import { PropTypes } from "prop-types";
const SectionHeader = props => {
  return (
    <div>
      {props.showHr && <HorizontalRule />}
      <div className={"sectionHeader"}>
        <Text kind="title/xs" asChild>
          <div role="heading" aria-level={3}>{props.title}</div>
        </Text>
      </div>
    </div>
  );
};

SectionHeader.defaultProps = {
  showHr: true
};

SectionHeader.propTypes = {
  showHr: PropTypes.bool,
  title: PropTypes.string.isRequired
};

export default SectionHeader;
